import { Build } from '@stencil/core';
import {
    Link,
    CmsLink,
    TopMenuCmsConfigurationInterface,
    TopMenuConfigurationInterface
} from '../interfaces/top-menu-configuration-interface';

export class TopMenuService {
    private readonly configuration: Promise<TopMenuConfigurationInterface>;

    constructor() {
        this.configuration = Build.isBrowser
            ? fetch('/static/api/top-menu.json').then(async (response) => {
                  const data = (await response.json()) as unknown;
                  return this.mapCmsLinks(data as TopMenuCmsConfigurationInterface)

              })
            : Promise.resolve({} as TopMenuConfigurationInterface);
    }

    private mapCmsLinks(data: TopMenuCmsConfigurationInterface): TopMenuConfigurationInterface {
        return {
            menuLink: this.mapToLink(data.menuLink),
            questionLink: this.mapToLink(data.questionLink),
            menuItems: data.menuItems.map(this.mapToLink.bind(this))
        };
    }

    private mapToLink(cmsLink: CmsLink): Link {
        return {
            ...cmsLink,
            linkText: cmsLink.text,
            linkTitle: cmsLink.title,
            iconStart: cmsLink.iconStart?.name ?? '',
            iconEnd: cmsLink.iconEnd?.name ?? ''
        };
    }
    getConfiguration() {
        return Build.isBrowser
            ? this.configuration.then(configuration => configuration)
            : Promise.resolve({} as TopMenuConfigurationInterface);
    }
}
